import { useEffect, useState } from 'react';
import { callAPI } from '../hooks/CallAPI';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from "../hooks/useAuth";

const useFetchData = (path) => {
    const [data, setData] = useState(null);
    const [user] = useLocalStorage("user", null);
    const location = useLocation();
    const { logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseData = await callAPI(path || location.pathname, { access_token: user.access_token });
                setData(responseData.datas);

                if (responseData.code == 501) {
                    logout(false)
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                toast.warning('Un erreur est survenue lors de la récupération des données')
                setTimeout(() => {
                    navigate('/dashboard')
                }, 1500)
            }
        };

        fetchData();
    }, [path, location.pathname, user.access_token]);

    return data;
};

export default useFetchData;